import { apiCall } from '.';
import { CardDisbursementDto, CardRepaymentDto, VerifyDisbursementDto, VerifyRepaymentDto, WalletDisbursementDto, WalletRepaymentDto } from '../interfaces/payment';

export const cardsApi = () => {
  return apiCall(true).get('/user/cards');
};

export const verifyDisbursementApi = (payload: VerifyDisbursementDto) => {
  return apiCall(true).post('transactions/verify-loan-disbursement', payload);
};

export const cardDisbursementApi = (payload: CardDisbursementDto) => {
  return apiCall(true).post('transactions/card-loan-disbursement', payload);
};

export const walletDisbursementApi = (payload: WalletDisbursementDto) => {
  return apiCall(true).post('transactions/wallet-loan-disbursement', payload);
};

export const verifyRepaymentApi = (payload: VerifyRepaymentDto) => {
  return apiCall(true).post('transactions/verify-loan-repayment', payload);
};

export const cardRepaymentApi = (payload: CardRepaymentDto) => {
  return apiCall(true).post('transactions/card-loan-repayment', payload);
};

export const walletRepaymentApi = (payload: WalletRepaymentDto) => {
  return apiCall(true).post('transactions/wallet-loan-repayment', payload);
};
